(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aw-discovery-directory"] && !Shopify.designMode) return;
  try {
    
(() => {
  const input = document.querySelector('[data-aw-directory-search]');
  if (!input) return;
  const cards = Array.from(document.querySelectorAll('[data-aw-directory-card]'));
  const status = document.querySelector('[data-aw-directory-status]');
  const update = () => {
    const query = input.value.trim().toLowerCase();
    let visible = 0;
    cards.forEach(card => {
      const name = (card.dataset.awDirectoryName || '').toLowerCase();
      const show = !query || name.includes(query);
      card.hidden = !show;
      if (show) visible += 1;
    });
    if (status) {
      status.textContent = query ? visible + (visible === 1 ? ' result' : ' results') : '';
    }
  };
  input.addEventListener('input', update);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aw-notes-directory"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('aw-note-directory')) {
  customElements.define('aw-note-directory', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.query = this.querySelector('[data-note-query]');
      this.stage = this.querySelector('[data-note-stage]');
      this.cards = [...this.querySelectorAll('[data-note-product]')];
      this.noteValueNodes = [...this.querySelectorAll('[data-note-values]')];
      this.noteValueNodes.forEach(node => { if (!node.dataset.noteOriginal) node.dataset.noteOriginal = node.textContent; });
      const choices = this.querySelector('[data-note-choices]');
      const notes = [...new Set([...this.querySelectorAll('[data-note-values]')].flatMap(node => (node.dataset.noteOriginal || node.textContent).split(/[,;]/)).map(value => value.trim()).filter(Boolean))].sort((a,b) => a.localeCompare(b));
      notes.forEach(note => { const option = document.createElement('option'); option.value = note; choices.append(option); });
      const initial = new URLSearchParams(window.location.search).get('note');
      if (initial) this.query.value = initial;
      this.glossaryQuery = this.closest('.aw-note-directory').querySelector('[data-glossary-query]');
      this.glossaryEntries = [...this.closest('.aw-note-directory').querySelectorAll('[data-note-definition]')];
      if (this.glossaryQuery) {
        if (initial) this.glossaryQuery.value = initial;
        let glossaryFrame = 0;
        this.glossaryQuery.addEventListener('input', () => {
          cancelAnimationFrame(glossaryFrame);
          glossaryFrame = requestAnimationFrame(() => this.filterGlossary());
        }, { passive: true });
        this.filterGlossary();
      }
      if (initial) {
        const wanted = this.normalize(initial);
        const entry = this.glossaryEntries.find(item => this.normalize(item.dataset.noteName) === wanted);
        if (entry) entry.open = true;
      }
      let filterFrame = 0;
      const scheduleFilter = () => {
        cancelAnimationFrame(filterFrame);
        filterFrame = requestAnimationFrame(() => this.filter());
      };
      this.query.addEventListener('input', scheduleFilter, { passive: true });
      this.stage.addEventListener('change', scheduleFilter);
      this.querySelector('[data-note-clear]').addEventListener('click', () => { this.query.value = ''; this.stage.value = 'all'; this.filter(); this.query.focus(); });
      this.querySelector('[data-note-filters]').hidden = false;
      this.filter();
    }
    normalize(text) { return text.normalize('NFKD').replace(/[\u0300-\u036f]/g,'').toLowerCase().trim(); }
    filterGlossary() {
      if (!this.glossaryQuery) return;
      const query = this.normalize(this.glossaryQuery.value);
      let visible = 0;
      this.glossaryEntries.forEach(entry => {
        const matches = !query || this.normalize(entry.dataset.noteName).includes(query);
        entry.hidden = !matches;
        if (matches) visible++;
      });
      const empty = this.closest('.aw-note-directory').querySelector('[data-glossary-empty]');
      if (empty) empty.hidden = visible !== 0;
    }
    highlightSelectedNote() {
      const rawQuery = this.query.value.trim();
      const query = rawQuery.toLowerCase();
      this.noteValueNodes.forEach(node => {
        const original = node.dataset.noteOriginal || node.textContent;
        node.replaceChildren();
        if (!query) {
          const parts = original.split(/[,;]/).map(value => value.trim()).filter(Boolean);
          parts.forEach((note,index) => {
            if (index) node.append(document.createTextNode(', '));
            const link = document.createElement('a');
            link.className = 'aw-note-master-link';
            link.href = (document.querySelector('.aw-note-directory')?.dataset.notesUrl || '/pages/perfume-notes') + '?note=' + encodeURIComponent(note) + '#note-guide';
            link.textContent = note;
            node.append(link);
          });
          return;
        }
        const lower = original.toLowerCase();
        let start = 0;
        let index = lower.indexOf(query);
        if (index === -1) {
          node.textContent = original;
          return;
        }
        while (index !== -1) {
          if (index > start) node.append(document.createTextNode(original.slice(start,index)));
          const mark = document.createElement('mark');
          mark.className = 'aw-note-highlight';
          const link = document.createElement('a');
          link.className = 'aw-note-master-link';
          link.href = (document.querySelector('.aw-note-directory')?.dataset.notesUrl || '/pages/perfume-notes') + '?note=' + encodeURIComponent(rawQuery) + '#note-guide';
          link.textContent = original.slice(index,index + rawQuery.length);
          mark.append(link);
          node.append(mark);
          start = index + rawQuery.length;
          index = lower.indexOf(query,start);
        }
        if (start < original.length) node.append(document.createTextNode(original.slice(start)));
      });
    }
    filter() {
      const query = this.normalize(this.query.value);
      this.highlightSelectedNote();
      let count = 0;
      this.cards.forEach(card => {
        const values = [...card.querySelectorAll('[data-note-values]')].filter(node => this.stage.value === 'all' || node.dataset.noteValues === this.stage.value);
        const title = this.stage.value === 'all' ? card.querySelector('h2').textContent : '';
        const matches = !query || this.normalize(title + ' ' + values.map(node => node.textContent).join(' ')).includes(query);
        card.hidden = !matches; if (matches) count++;
      });
      const status = this.querySelector('[data-note-count]'); status.textContent = status.dataset.label + ': ' + count;
      this.querySelector('[data-note-empty]').hidden = count !== 0;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aw-pick-three-bundle"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pick-three-bundle')) {
    customElements.define('pick-three-bundle', class extends HTMLElement {
      connectedCallback() {
        this.limit = Number(this.dataset.limit || 3);
        this.expectedVariant = this.dataset.variantMatch.trim().toLowerCase();
        this.expectedPrice = Number(this.dataset.eligiblePrice);
        this.checkoutMode = this.dataset.checkoutMode;
        this.bundleProductVariant = this.dataset.bundleProductVariant;
        this.selected = new Map();
        this.cards = Array.from(this.querySelectorAll('[data-bundle-card]'));
        this.selectedContainer = this.querySelector('[data-bundle-selected]');
        this.countElement = this.querySelector('[data-bundle-count]');
        this.checkoutCountElement = this.querySelector('[data-bundle-checkout-count]');
        this.messageElement = this.querySelector('[data-bundle-message]');
        this.submitButton = this.querySelector('[data-bundle-submit]');
        this.errorElement = this.querySelector('[data-bundle-error]');
        this.searchInput = this.querySelector('[data-bundle-search]');
        this.genderButtons = Array.from(this.querySelectorAll('[data-gender-filter]'));
        this.scentFilter = this.querySelector('[data-scent-filter]');
        this.activeGender = 'all';
        this.emptyElement = this.querySelector('[data-bundle-empty]');
        this.storageKey = `aw-pick-three:${window.location.pathname}`;

        this.cards.forEach((card) => {
          card.querySelector('[data-bundle-select]').addEventListener('click', () => this.toggleCard(card));
        });
        this.genderButtons.forEach((button) => {
          button.addEventListener('click', () => {
            this.activeGender = button.dataset.genderFilter;
            this.genderButtons.forEach((filterButton) => {
              filterButton.setAttribute('aria-pressed', String(filterButton === button));
            });
            this.filterCards();
          });
        });
        this.scentFilter.addEventListener('change', () => this.filterCards());
        this.searchInput.addEventListener('input', () => this.filterCards());
        this.submitButton.addEventListener('click', () => this.addBundle());
        this.restore();
        this.render();
      }

      toggleCard(card) {
        const variantId = card.dataset.variantId;
        const isEligible = card.dataset.variantTitle === this.expectedVariant && Number(card.dataset.variantPrice) === this.expectedPrice;
        if (!isEligible) return;
        if (this.selected.has(variantId)) {
          this.selected.delete(variantId);
        } else if (this.selected.size < this.limit) {
          this.selected.set(variantId, {
            variantId,
            variantTitle: card.dataset.variantTitle,
            variantPrice: Number(card.dataset.variantPrice),
            productId: card.dataset.productId,
            title: card.dataset.productTitle,
            image: card.dataset.productImage,
            url: card.dataset.productUrl
          });
        }
        this.save();
        this.render();
      }

      remove(variantId) {
        this.selected.delete(variantId);
        this.save();
        this.render();
      }

      render() {
        const isFull = this.selected.size === this.limit;
        this.cards.forEach((card) => {
          const button = card.querySelector('[data-bundle-select]');
          const isSelected = this.selected.has(card.dataset.variantId);
          card.classList.toggle('is-selected', isSelected);
          button.setAttribute('aria-pressed', String(isSelected));
          button.textContent = isSelected ? this.dataset.selectedLabel : this.dataset.addLabel;
          button.disabled = isFull && !isSelected;
        });

        this.selectedContainer.replaceChildren();
        this.selected.forEach((item) => {
          const wrapper = document.createElement('div');
          wrapper.className = 'aw-pick-three__selected-item';

          const image = document.createElement('img');
          image.src = item.image;
          image.alt = '';
          image.width = 64;
          image.height = 64;
          image.loading = 'eager';

          const title = document.createElement('p');
          title.className = 'aw-pick-three__selected-title';
          title.textContent = item.title;

          const removeButton = document.createElement('button');
          removeButton.className = 'aw-pick-three__remove';
          removeButton.type = 'button';
          removeButton.textContent = '×';
          removeButton.setAttribute('aria-label', `${this.dataset.removeLabel} ${item.title}`);
          removeButton.addEventListener('click', () => this.remove(item.variantId));

          wrapper.append(image, title, removeButton);
          this.selectedContainer.append(wrapper);
        });

        this.countElement.textContent = `${this.selected.size} ${this.dataset.countLabel}`;
        this.checkoutCountElement.textContent = `${this.selected.size} ${this.dataset.countLabel}`;
        this.messageElement.textContent = isFull ? this.dataset.readyLabel : this.dataset.chooseLabel;
        this.submitButton.disabled = !isFull;
      }

      filterCards() {
        const query = this.searchInput.value.trim().toLowerCase();
        const scent = this.scentFilter.value;
        let visibleCount = 0;
        this.cards.forEach((card) => {
          const matchesSearch = !query || card.dataset.searchText.includes(query);
          const matchesGender = this.activeGender === 'all' || card.dataset.gender === this.activeGender;
          const matchesScent = scent === 'all' || card.dataset.scentFamilies.includes(scent);
          const visible = matchesSearch && matchesGender && matchesScent;
          card.hidden = !visible;
          if (visible) visibleCount += 1;
        });
        this.emptyElement.hidden = visibleCount !== 0;
      }

      save() {
        sessionStorage.setItem(this.storageKey, JSON.stringify(Array.from(this.selected.values())));
      }

      restore() {
        try {
          const saved = JSON.parse(sessionStorage.getItem(this.storageKey) || '[]');
          saved
            .filter((item) => item.variantTitle === this.expectedVariant && Number(item.variantPrice) === this.expectedPrice)
            .slice(0, this.limit)
            .forEach((item) => this.selected.set(String(item.variantId), item));
        } catch (error) {
          sessionStorage.removeItem(this.storageKey);
        }
      }

      async addBundle() {
        if (this.selected.size !== this.limit) return;
        const hasInvalidItem = Array.from(this.selected.values()).some((item) => item.variantTitle !== this.expectedVariant || Number(item.variantPrice) !== this.expectedPrice);
        if (hasInvalidItem) {
          sessionStorage.removeItem(this.storageKey);
          this.selected.clear();
          this.render();
          this.errorElement.textContent = this.dataset.errorLabel;
          this.errorElement.hidden = false;
          return;
        }
        this.submitButton.disabled = true;
        this.errorElement.hidden = true;
        const bundleId = `AW-${Date.now()}`;
        const selectedItems = Array.from(this.selected.values());
        let items;

        if (this.checkoutMode === 'bundle_product') {
          if (!this.bundleProductVariant) {
            this.errorElement.textContent = this.dataset.errorLabel;
            this.errorElement.hidden = false;
            this.submitButton.disabled = false;
            return;
          }

          const properties = {
            '_Bundle': this.dataset.bundleLabel,
            '_Bundle ID': bundleId
          };
          selectedItems.forEach((item, index) => {
            properties[`Scent ${index + 1}`] = `${item.title} — ${item.variantTitle}`;
          });
          items = [{
            id: Number(this.bundleProductVariant),
            quantity: 1,
            properties
          }];
        } else {
          items = selectedItems.map((item) => ({
            id: Number(item.variantId),
            quantity: 1,
            properties: {
              '_Bundle': this.dataset.bundleLabel,
              '_Bundle ID': bundleId
            }
          }));
        }

        try {
          const response = await fetch(`${this.dataset.rootUrl}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          sessionStorage.removeItem(this.storageKey);
          const code = this.dataset.discountCode.trim();
          if (code && this.checkoutMode !== 'bundle_product') {
            window.location.assign(`${this.dataset.rootUrl}discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(this.dataset.cartUrl)}`);
          } else {
            window.location.assign(this.dataset.cartUrl);
          }
        } catch (error) {
          this.errorElement.textContent = this.dataset.errorLabel;
          this.errorElement.hidden = false;
          this.submitButton.disabled = false;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aw-scent-quiz"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('aw-scent-quiz')) {
  customElements.define('aw-scent-quiz', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.labels = JSON.parse(this.querySelector('[data-quiz-labels]').textContent);
      this.products = JSON.parse(this.querySelector('[data-quiz-products]').textContent).map(p => this.prepareProduct(p)).filter(p => p.noteList.length);
      this.form = this.querySelector('[data-quiz-form]');
      this.steps = Array.from(this.querySelectorAll('[data-quiz-step]'));
      this.results = this.querySelector('[data-quiz-results]');
      this.error = this.querySelector('[data-quiz-error]');
      this.selectedNotes = {likes: new Set(), avoids: new Set()};
      this.index = 0;
      this.form.hidden = false;
      this.form.addEventListener('submit', event => {
        event.preventDefault();
        const step = this.steps[this.index];
        if (!step.dataset.noteStep && !step.querySelector('input:checked')) {
          this.error.textContent = this.labels.required;
          this.error.hidden = false;
          step.querySelector('input').focus();
          return;
        }
        if (this.index < this.steps.length - 1) { this.index++; this.showStep(true); }
        else this.showResults();
      });
      this.form.addEventListener('change', event => {
        if (event.target.name === 'gender') {
          try { localStorage.setItem('aw_scent_gender', event.target.value); } catch (error) {}
          this.selectedNotes.likes.clear();
          this.selectedNotes.avoids.clear();
          this.querySelectorAll('[data-note-search]').forEach(input => { input.value = ''; });
        }
        const kind = event.target.dataset.noteChoice;
        if (!kind) return;
        const selected = this.selectedNotes[kind];
        if (event.target.checked && selected.size >= 3) {
          event.target.checked = false;
          this.error.textContent = this.labels.note_limit;
          this.error.hidden = false;
          return;
        }
        if (event.target.checked) {
          selected.add(event.target.value);
          this.selectedNotes[kind === 'likes' ? 'avoids' : 'likes'].delete(event.target.value);
        } else selected.delete(event.target.value);
        this.error.hidden = true;
        this.updateNoteCount(kind);
      });
      this.querySelectorAll('[data-note-search]').forEach(input => input.addEventListener('input', () => {
        input.closest('[data-note-step]').dataset.expanded = 'false';
        this.renderNotes(input.dataset.noteSearch);
      }));
      this.querySelectorAll('[data-note-more]').forEach(button => button.addEventListener('click', () => {
        const step = button.closest('[data-note-step]');
        step.dataset.expanded = step.dataset.expanded === 'true' ? 'false' : 'true';
        this.renderNotes(button.dataset.noteMore);
      }));
      this.querySelector('[data-quiz-back]').addEventListener('click', () => { this.index--; this.showStep(true); });
      this.querySelector('[data-quiz-restart]').addEventListener('click', () => {
        this.form.reset(); this.selectedNotes.likes.clear(); this.selectedNotes.avoids.clear();
        this.index = 0; this.results.hidden = true; this.form.hidden = false; this.showStep(true);
      });
      const rail = this.querySelector('[data-quiz-cards]');
      this.querySelectorAll('[data-quiz-slide]').forEach(button => button.addEventListener('click', () => {
        const first = rail.firstElementChild;
        if (!first) return;
        const distance = first.getBoundingClientRect().width + parseFloat(getComputedStyle(rail).columnGap || 0);
        rail.scrollBy({left: Number(button.dataset.quizSlide) * distance, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      }));
      rail.addEventListener('scroll', () => this.updateCarousel(), {passive:true});
      this.carouselObserver = new ResizeObserver(() => this.updateCarousel());
      this.carouselObserver.observe(rail);
      this.querySelector('[data-quiz-open-notes]').addEventListener('click', () => {
        this.selectedNotes.likes.clear();
        const search = this.querySelector('[data-note-search="likes"]');
        if (search) search.value = '';
        this.index = 3;
        this.showStep(true);
      });
      this.querySelector('[data-quiz-no-avoids]').addEventListener('click', () => {
        this.selectedNotes.avoids.clear(); this.index = 4; this.showStep(true);
      });
      this.querySelectorAll('[data-quiz-edit-avoids]').forEach(button => button.addEventListener('click', () => {
        this.results.hidden = true; this.form.hidden = false; this.index = 3; this.showStep(true);
      }));
      this.showStep(false);
    }
    disconnectedCallback() { this.carouselObserver?.disconnect(); }
    updateCarousel() {
      const rail = this.querySelector('[data-quiz-cards]');
      if (!rail || this.results.hidden) return;
      const overflow = rail.scrollWidth > rail.clientWidth + 2;
      this.querySelector('.aw-scent-quiz__carousel-controls').hidden = !overflow;
      this.querySelector('.aw-scent-quiz__swipe-hint').hidden = !overflow;
      this.querySelector('[data-quiz-slide="-1"]').disabled = rail.scrollLeft <= 2;
      this.querySelector('[data-quiz-slide="1"]').disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2;
      const first = rail.firstElementChild;
      const distance = first ? first.getBoundingClientRect().width + parseFloat(getComputedStyle(rail).columnGap || 0) : 1;
      this.querySelector('[data-quiz-position]').textContent = `${Math.round(rail.scrollLeft / distance) + 1} ${this.labels.of} ${rail.children.length}`;
    }
    normalizeNote(value) {
      return String(value).normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
    }
    noteMatches(note, preference) {
      return (' ' + this.normalizeNote(note) + ' ').includes(' ' + this.normalizeNote(preference) + ' ');
    }
    prepareProduct(product) {
      const notes = product.notes || {};
      const noteList = [...new Set(['top', 'heart', 'base'].flatMap(stage => String(notes[stage] || '').split(/[,;]/)).map(s => s.trim()).filter(Boolean))];
      const designer = (product.tags.find(t => t.startsWith('Designer: ')) || product.title.split(':')[0]).replace(/^Designer: /, '').trim();
      return {...product, noteList, designer};
    }
    genderProducts(gender) {
      const tag = {men: 'Men', women: 'Women', unisex: 'Unisex'}[gender];
      return this.products.filter(p => tag && p.tags.includes(tag));
    }
    noteOptions() {
      const gender = new FormData(this.form).get('gender');
      const counts = new Map();
      this.genderProducts(gender).forEach(product => {
        const seen = new Set();
        product.noteList.forEach(label => {
          const key = this.normalizeNote(label);
          if (seen.has(key)) return;
          seen.add(key);
          const current = counts.get(key) || {key, label: label.charAt(0).toUpperCase() + label.slice(1), count: 0};
          current.count++; counts.set(key, current);
        });
      });
      return [...counts.values()].sort((a,b) => b.count-a.count || a.label.localeCompare(b.label));
    }
    renderNotes(kind) {
      const step = this.querySelector('[data-note-step="' + kind + '"]');
      const search = this.normalizeNote(step.querySelector('[data-note-search]').value);
      const selected = this.selectedNotes[kind];
      const options = this.noteOptions().filter(note => selected.has(note.key) || note.key.includes(search)).sort((a,b) => Number(selected.has(b.key))-Number(selected.has(a.key)));
      const visible = step.dataset.expanded === 'true' ? options : options.slice(0,12);
      const target = step.querySelector('[data-note-options]'); target.replaceChildren();
      visible.forEach(note => {
        const label = this.node('label'); const input = this.node('input');
        input.type = 'checkbox'; input.value = note.key; input.dataset.noteChoice = kind; input.checked = selected.has(note.key);
        label.append(input, this.node('span', note.label)); target.append(label);
      });
      if (!options.length) target.append(this.node('p', this.labels.no_notes));
      const more = step.querySelector('[data-note-more]'); more.hidden = options.length <= 12;
      more.textContent = step.dataset.expanded === 'true' ? this.labels.show_less : this.labels.show_all;
      this.updateNoteCount(kind);
    }
    updateNoteCount(kind) {
      this.querySelector('[data-note-count="' + kind + '"]').textContent = this.labels.selected + ' ' + this.selectedNotes[kind].size + ' / 3';
    }
    showStep(focus) {
      this.steps.forEach((step,i) => { step.hidden = i !== this.index; });
      this.error.hidden = true;
      this.querySelector('[data-quiz-back]').hidden = this.index === 0;
      this.querySelector('[data-quiz-next]').textContent = this.index === this.steps.length - 1 ? this.labels.finish : this.labels.next;
      const progress = this.querySelector('[data-quiz-progress]'); progress.hidden = false;
      progress.textContent = `${this.labels.step} ${this.index+1} ${this.labels.of} ${this.steps.length}`;
      const step = this.steps[this.index];
      if (step.dataset.noteStep) this.renderNotes(step.dataset.noteStep);
      if (focus) step.querySelector('legend').focus();
    }
    familyNotes(product, family) {
      const patterns = {
        fresh: /\b(bergamot|lemon|lime|mandarin|tangerine|orange|grapefruit|citrus|citron|mint|water|seawater|marine|aquatic|green|tea|petitgrain|verbena|neroli)\b/,
        floral: /\b(jasmine|rose|peony|violet|lavender|iris|orris|flower|flowers|floral|orchid|tuberose|gardenia|freesia|lily|lilac|geranium|ylang|honeysuckle|heliotrope|magnolia|osmanthus|hyacinth|blossom|neroli)\b/,
        sweet: /\b(vanilla|tonka|sugar|caramel|praline|chocolate|cocoa|marshmallow|candy|cream|honey|almond|pistachio|hazelnut|coffee|coconut|gourmand|sweet|benzoin)\b/,
        woody: /\b(wood|woods|woody|woodsy|cedar|cedarwood|sandalwood|oud|agarwood|vetiver|patchouli|oak|oakmoss|papyrus|cypriol|moss|bamboo|guaiac)\b/,
        amber: /\b(amber|amberwood|ambergris|labdanum|benzoin|balsam|myrrh|incense|frankincense|spice|spices|spicy|cinnamon|cardamom|pepper|saffron|ginger|nutmeg|clove|cloves|coriander)\b/
      };
      const pattern = patterns[family];
      return pattern ? product.noteList.filter(note => pattern.test(this.normalizeNote(note))) : [];
    }
    tieKey(value) {
      let hash = 2166136261;
      for (let i=0;i<value.length;i++) { hash ^= value.charCodeAt(i); hash = Math.imul(hash,16777619); }
      return hash >>> 0;
    }
    recommend(answers, likes, avoids) {
      const seed = JSON.stringify([answers.gender,answers.family,answers.mood,answers.occasion,[...likes].sort(),[...avoids].sort()]);
      const ranked = this.genderProducts(answers.gender).map(product => {
        if (avoids.some(preference => product.noteList.some(note => this.noteMatches(note,preference)))) return null;
        const preferred = likes.filter(preference => product.noteList.some(note => this.noteMatches(note,preference)));
        if (likes.length && !preferred.length) return null;
        const familyMatches = this.familyNotes(product,answers.family);
        if (answers.family !== 'unsure' && !familyMatches.length) return null;
        const moodFamilies = {light:['fresh'],soft:['floral','sweet'],deep:['woody','amber'],open:[]}[answers.mood] || [];
        const occasionFamilies = {daily:['fresh','floral'],evening:['amber','sweet','woody'],travel:['fresh'],all:[]}[answers.occasion] || [];
        const fraction = families => new Set(families.flatMap(f => this.familyNotes(product,f))).size / product.noteList.length;
        const score = preferred.length*24 + familyMatches.length/product.noteList.length*18 + fraction(moodFamilies)*3 + fraction(occasionFamilies)*2;
        return {product,score,preferred,familyMatches,tie:this.tieKey(seed+product.url)};
      }).filter(Boolean).sort((a,b) => b.score-a.score || a.tie-b.tie);
      const selected = []; const remaining = [...ranked]; const designers = new Set();
      while (remaining.length && selected.length < 3) {
        const best = remaining[0];
        const alternative = remaining.findIndex(item => item.preferred.length === best.preferred.length && item.score >= best.score-2 && !designers.has(item.product.designer));
        const index = alternative >= 0 ? alternative : 0;
        const item = remaining.splice(index,1)[0]; selected.push(item); designers.add(item.product.designer);
      }
      return selected;
    }
    node(tag,text,className) { const node=document.createElement(tag); if(text)node.textContent=text; if(className)node.className=className; return node; }
    noteLink(note) {
      const link = this.node('a', note);
      link.href = this.dataset.notesUrl + '?note=' + encodeURIComponent(note) + '#note-guide';
      link.className = 'aw-note-link';
      return link;
    }
    noteList(value) {
      const fragment = document.createDocumentFragment();
      String(value || '').split(/[,;]/).map(note => note.trim()).filter(Boolean).forEach((note,index) => {
        if (index) fragment.append(document.createTextNode(', '));
        fragment.append(this.noteLink(note));
      });
      return fragment;
    }
    showResults() {
      const answers = Object.fromEntries(new FormData(this.form));
      const likes = [...this.selectedNotes.likes]; const avoids = [...this.selectedNotes.avoids];
      const picks = this.recommend(answers,likes,avoids);
      const cards = this.querySelector('[data-quiz-cards]'); cards.replaceChildren();
      picks.forEach(({product,preferred,familyMatches}) => {
        const card = this.node('article',null,'aw-scent-quiz__card');
        if (product.image) { const image=this.node('img'); image.src=product.image; image.alt=product.alt; image.width=480; image.height=480; image.loading='lazy'; card.append(image); }
        card.append(this.node('h3',product.title));
        const featuredNotes = this.node('dl',null,'aw-card-notes');
        ['top','heart','base'].forEach(stage => {
          const note = String(product.notes[stage] || '').split(/[,;]/)[0].trim();
          if (!note) return;
          const part = this.node('div');
          const dd = this.node('dd');
          const noteLink = this.noteLink(note);
          if (note.length > 18) noteLink.classList.add('aw-note-link--xlong');
          else if (note.length > 11) noteLink.classList.add('aw-note-link--long');
          dd.append(noteLink);
          part.append(this.node('dt',this.labels['short_'+stage]),dd);
          featuredNotes.append(part);
        });
        if (featuredNotes.childElementCount) card.append(featuredNotes);
        const price = this.node('p',null,'aw-scent-quiz__price');
        if (product.varies) price.append(this.node('span',this.labels.from));
        price.append(document.createTextNode(product.price)); card.append(price);
        if (preferred.length || familyMatches.length) {
          const match = this.node('div',null,'aw-scent-quiz__match');
          const matchingNotes = preferred.length ? product.noteList.filter(note => preferred.some(preference => this.noteMatches(note,preference))) : familyMatches.slice(0,4);
          const label = (preferred.length ? this.labels.loved_match : this.labels.match).replace(/:\s*$/, '');
          const matchValue = this.node('span',null,'aw-scent-quiz__match-value');
          matchingNotes.forEach((note,index) => {
            if (index) matchValue.append(document.createTextNode(' · '));
            matchValue.append(this.noteLink(note));
          });
          match.append(this.node('span',label,'aw-scent-quiz__match-label'),matchValue);
          if (preferred.length && preferred.length < likes.length) match.append(this.node('p',this.labels.partial_match+' '+preferred.length+' / '+likes.length,'aw-scent-quiz__match-partial'));
          card.append(match);
        }
        if (!preferred.length && !familyMatches.length) card.append(this.node('p',this.labels.discover));
        const details = this.node('details',null,'aw-scent-quiz__notes');
        details.append(this.node('summary',this.labels.full_notes));
        const pyramid = this.node('dl',null,'aw-scent-quiz__note-pyramid');
        ['top','heart','base'].forEach(stage => {
          if(product.notes[stage]) {
            const row=this.node('div');
            const dd=this.node('dd');
            dd.append(this.noteList(product.notes[stage]));
            row.append(this.node('dt',this.labels['short_'+stage]),dd);
            pyramid.append(row);
          }
        });
        details.append(pyramid);
        card.append(details);
        const link = this.node('a',this.labels.shop,'aw-scent-quiz__shop'); link.href=product.url; card.append(link); cards.append(card);
      });
      const status=this.querySelector('[data-result-status]'); status.hidden = picks.length===3;
      status.textContent = picks.length ? this.labels.fewer : this.labels.empty;
      this.form.hidden=true; this.results.hidden=false; this.querySelector('[data-quiz-progress]').hidden=true; this.results.querySelector('h2').focus(); cards.scrollLeft = 0; this.updateCarousel();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aw-wholesale-builder"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('[data-aw-wholesale]');
  if (!root) return;

  const variantId = Number(root.dataset.variantId || 0);
  const unitPrice = Number(root.dataset.unitPrice || 500);
  const minimumUnits = Number(root.dataset.minimumUnits || 40);
  const cards = [...root.querySelectorAll('.aw-wholesale-card')];
  const status = root.querySelector('[data-aw-wholesale-status]');
  const search = root.querySelector('[data-aw-wholesale-search]');
  const filters = [...root.querySelectorAll('[data-aw-filter]')];
  const noteFilter = root.querySelector('[data-aw-note-filter]');
  const dock = root.querySelector('[data-aw-wholesale-dock]');
  const countNode = root.querySelector('[data-aw-wholesale-count]');
  const totalNode = root.querySelector('[data-aw-wholesale-total]');
  const progressNode = root.querySelector('[data-aw-wholesale-progress]');
  const messageNode = root.querySelector('[data-aw-wholesale-message]');
  const addButton = root.querySelector('[data-aw-wholesale-add]');
  const selections = new Map();
  let activeFilter = 'all';

  const products = cards.map((card) => ({
    handle: card.dataset.handle,
    title: card.dataset.title,
    gender: card.dataset.gender || 'all',
    bestSeller: card.dataset.bestSeller === 'true',
    notes: card.dataset.notes || '',
    card
  }));

  const formatMoney = (cents) => {
    if (window.Shopify?.currency?.active) {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: window.Shopify.currency.active }).format(cents / 100);
    }
    return '$' + (cents / 100).toFixed(2);
  };

  const totals = () => {
    let count = 0;
    selections.forEach((qty) => { count += qty; });
    return { count, total: count * unitPrice };
  };

  const syncDock = () => {
    const { count, total } = totals();
    dock.hidden = false;
    countNode.textContent = String(count);
    totalNode.textContent = formatMoney(total);
    progressNode.style.width = Math.min(100, (count / minimumUnits) * 100) + '%';
    addButton.disabled = count < minimumUnits || !variantId;

    if (count >= minimumUnits) {
      messageNode.textContent = root.dataset.textMinimumMet;
    } else {
      const remaining = minimumUnits - count;
      messageNode.textContent = remaining + ' roll-on' + (remaining === 1 ? '' : 's') + ' ' + root.dataset.textRemaining;
    }
  };

  const updateCard = (product) => {
    const qty = selections.get(product.handle) || 0;
    product.card.querySelector('output').textContent = String(qty);
    product.card.classList.toggle('is-selected', qty > 0);
  };

  const render = () => {
    const term = search.value.trim().toLowerCase();
    let visibleCount = 0;

    products.forEach((product) => {
      const filterMatch = activeFilter === 'all'
        || (activeFilter === 'best-sellers' && product.bestSeller)
        || product.gender === activeFilter;
      const selectedNote = noteFilter ? noteFilter.value : '';
      const noteMatch = !selectedNote || product.notes.split('|').includes(selectedNote);
      const termMatch = !term || product.title.toLowerCase().includes(term);
      const visible = filterMatch && noteMatch && termMatch;
      product.card.classList.toggle('is-filtered-out', !visible);
      if (visible) visibleCount += 1;
    });

    status.textContent = visibleCount ? '' : root.dataset.textEmpty;
  };

  products.forEach((product) => {
    const minus = product.card.querySelector('[data-action="minus"]');
    const plus = product.card.querySelector('[data-action="plus"]');

    minus.addEventListener('click', () => {
      const current = selections.get(product.handle) || 0;
      if (current <= 1) selections.delete(product.handle);
      else selections.set(product.handle, current - 1);
      updateCard(product);
      syncDock();
    });

    plus.addEventListener('click', () => {
      const current = selections.get(product.handle) || 0;
      selections.set(product.handle, current + 1);
      updateCard(product);
      syncDock();
    });
  });

  search.addEventListener('input', render);
  if (noteFilter) noteFilter.addEventListener('change', render);
  filters.forEach((button) => {
    button.addEventListener('click', () => {
      activeFilter = button.dataset.awFilter;
      filters.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
      render();
    });
  });

  addButton.addEventListener('click', async () => {
    const { count } = totals();
    if (count < minimumUnits || !variantId) return;

    const items = products
      .filter((product) => (selections.get(product.handle) || 0) > 0)
      .map((product) => ({
        id: variantId,
        quantity: selections.get(product.handle),
        properties: {
          Scent: product.title,
          Size: '0.33 fl. oz. roll-on',
          _Wholesale: 'true'
        }
      }));

    addButton.disabled = true;
    addButton.textContent = root.dataset.textAdding;

    try {
      const response = await fetch(window.MinimogSettings?.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items })
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || 'Unable to add wholesale order');
      messageNode.textContent = root.dataset.textAdded;
      window.location.href = window.MinimogSettings?.routes?.cart || '/cart';
    } catch (error) {
      messageNode.textContent = error.message || root.dataset.textError;
      addButton.disabled = false;
      addButton.textContent = root.dataset.textAddOrder;
    }
  });

  if (!products.length) {
    status.textContent = root.dataset.textError;
  } else {
    status.textContent = '';
  }

  render();
  syncDock();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-page-header"]) return;
  try {
    
function fitAwCollectionTitles() {
  document.querySelectorAll('[data-aw-fit-collection-title]').forEach((title) => {
    title.style.fontSize = '';
    title.style.whiteSpace = 'nowrap';

    const available = title.clientWidth;
    const natural = title.scrollWidth;
    if (!available || !natural || natural <= available) return;

    const base = parseFloat(window.getComputedStyle(title).fontSize);
    const minimum = window.matchMedia('(max-width: 749px)').matches ? 16 : 26;
    const fitted = Math.max(minimum, Math.floor(base * (available / natural) * 0.96));
    title.style.fontSize = fitted + 'px';

    if (title.scrollWidth > title.clientWidth && fitted > minimum) {
      title.style.fontSize = Math.max(minimum, Math.floor(fitted * (title.clientWidth / title.scrollWidth) * 0.98)) + 'px';
    }
  });
}

fitAwCollectionTitles();
window.addEventListener('resize', fitAwCollectionTitles, { passive: true });
document.fonts?.ready?.then(fitAwCollectionTitles);

  } catch(e) { console.error(e); }
})();
})();
